import TableIcon from "./TableIcon"

export default TableIcon
